export default __webpack_public_path__ + "static/media/icon_all.ea68f43f.svg";